import React from 'react';
import { SettingsIcon, BeakerIcon, CheckCircleIcon } from 'lucide-react';
export function HowItWorksSection() {
  return <section className="py-16 bg-gray-50 relative overflow-hidden" data-id="element-220">
      {/* Decorative geometric shapes */}
      <div className="absolute top-20 left-10 w-24 h-24 bg-purple-200 rounded-full opacity-20 animate-pulse" data-id="element-221"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-blue-200 rounded-tr-3xl opacity-20 animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-222"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 border-2 border-indigo-200 rounded-full opacity-10 animate-spin" style={{
      animationDuration: '30s'
    }} data-id="element-223"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-224">
        <div className="text-center mb-12" data-id="element-225">
          <h2 className="text-3xl font-bold mb-4" data-id="element-226">⚙️ How the Study Works</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-227">
            We're inviting UK schools and MATs to join a large-scale RCT
            starting September 2026.
          </p>
        </div>
        {/* Timeline visualization */}
        <div className="max-w-4xl mx-auto mb-16 hidden md:block" data-id="element-228">
          <div className="relative" data-id="element-229">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-purple-400 via-indigo-400 to-blue-400" data-id="element-230"></div>
            {/* Timeline points */}
            <div className="relative z-10" data-id="element-231">
              {/* Point 1 - Recruitment */}
              <div className="flex items-center mb-16" data-id="element-232">
                <div className="w-1/2 pr-8 text-right" data-id="element-233">
                  <h4 className="text-lg font-bold text-purple-700" data-id="element-234">
                    January - May 2025
                  </h4>
                  <p className="text-gray-600" data-id="element-235">Recruitment</p>
                </div>
                <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold border-4 border-white shadow-lg" data-id="element-236">
                  1
                </div>
                <div className="w-1/2 pl-8" data-id="element-237">
                  <p className="text-gray-700" data-id="element-238">
                    Schools and MATs apply to participate in the study
                  </p>
                </div>
              </div>
              {/* Point 2 - Training */}
              <div className="flex items-center mb-16" data-id="element-239">
                <div className="w-1/2 pr-8 text-right" data-id="element-240">
                  <p className="text-gray-700" data-id="element-241">
                    Complete onboarding and preparation for study launch
                  </p>
                </div>
                <div className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold border-4 border-white shadow-lg" data-id="element-242">
                  2
                </div>
                <div className="w-1/2 pl-8" data-id="element-243">
                  <h4 className="text-lg font-bold text-purple-700" data-id="element-244">
                    June - July 2025
                  </h4>
                  <p className="text-gray-600" data-id="element-245">
                    Full-department introduction, training and set up
                  </p>
                </div>
              </div>
              {/* Point 3 - Study Begins */}
              <div className="flex items-center mb-16" data-id="element-246">
                <div className="w-1/2 pr-8 text-right" data-id="element-247">
                  <h4 className="text-lg font-bold text-indigo-700" data-id="element-248">
                    September 2026
                  </h4>
                  <p className="text-gray-600" data-id="element-249">
                    Study begins with baseline assessments
                  </p>
                </div>
                <div className="w-10 h-10 bg-indigo-500 rounded-full flex items-center justify-center text-white font-bold border-4 border-white shadow-lg" data-id="element-250">
                  3
                </div>
                <div className="w-1/2 pl-8" data-id="element-251">
                  <p className="text-gray-700" data-id="element-252">
                    Random assignment of classes to intervention or control
                    groups
                  </p>
                </div>
              </div>
              {/* Point 4 - Implementation */}
              <div className="flex items-center mb-16" data-id="element-253">
                <div className="w-1/2 pr-8 text-right" data-id="element-254">
                  <p className="text-gray-700" data-id="element-255">
                    Weekly Eedi implementation for intervention classes
                  </p>
                </div>
                <div className="w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center text-white font-bold border-4 border-white shadow-lg" data-id="element-256">
                  4
                </div>
                <div className="w-1/2 pl-8" data-id="element-257">
                  <h4 className="text-lg font-bold text-indigo-700" data-id="element-258">
                    October 2026 - June 2027
                  </h4>
                  <p className="text-gray-600" data-id="element-259">
                    Ongoing implementation and support
                  </p>
                </div>
              </div>
              {/* Point 5 - Conclusion */}
              <div className="flex items-center" data-id="element-260">
                <div className="w-1/2 pr-8 text-right" data-id="element-261">
                  <h4 className="text-lg font-bold text-blue-700" data-id="element-262">July 2027</h4>
                  <p className="text-gray-600" data-id="element-263">
                    Study concludes with final assessments
                  </p>
                </div>
                <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold border-4 border-white shadow-lg" data-id="element-264">
                  5
                </div>
                <div className="w-1/2 pl-8" data-id="element-265">
                  <p className="text-gray-700" data-id="element-266">
                    All classes gain full access to Eedi for the following year
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-267">
          <div className="bg-white rounded-xl shadow-md overflow-hidden h-full transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1" data-id="element-268">
            <div className="p-6 h-full" data-id="element-269">
              <div className="flex items-center mb-4" data-id="element-270">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-271">
                  <SettingsIcon className="w-5 h-5 text-purple-600" data-id="element-272" />
                </div>
                <h3 className="text-xl font-bold" data-id="element-273">Eedi Implementation</h3>
              </div>
              <p className="text-gray-700 mb-6" data-id="element-274">
                Students will use Eedi at least once a week for:
              </p>
              <ul className="space-y-4 mb-6" data-id="element-275">
                <li className="flex items-start" data-id="element-276">
                  <div className="mt-1 mr-3 text-purple-500" data-id="element-277">
                    <CheckCircleIcon size={18} data-id="element-278" />
                  </div>
                  <div data-id="element-279">
                    <span className="font-medium text-gray-800" data-id="element-280">
                      In-class diagnostic quizzes
                    </span>
                    <p className="text-gray-600 text-sm" data-id="element-281">
                      Quickly identify and address misconceptions
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-282">
                  <div className="mt-1 mr-3 text-purple-500" data-id="element-283">
                    <CheckCircleIcon size={18} data-id="element-284" />
                  </div>
                  <div data-id="element-285">
                    <span className="font-medium text-gray-800" data-id="element-286">
                      Homework assignments
                    </span>
                    <p className="text-gray-600 text-sm" data-id="element-287">
                      With instant feedback and tutor support
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-288">
                  <div className="mt-1 mr-3 text-purple-500" data-id="element-289">
                    <CheckCircleIcon size={18} data-id="element-290" />
                  </div>
                  <div data-id="element-291">
                    <span className="font-medium text-gray-800" data-id="element-292">
                      Small group interventions
                    </span>
                    <p className="text-gray-600 text-sm" data-id="element-293">
                      Based on real-time data and analysis
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-md overflow-hidden h-full transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1" data-id="element-294">
            <div className="p-6 h-full" data-id="element-295">
              <div className="flex items-center mb-4" data-id="element-296">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-297">
                  <BeakerIcon className="w-5 h-5 text-blue-600" data-id="element-298" />
                </div>
                <h3 className="text-xl font-bold" data-id="element-299">Research Design</h3>
              </div>
              <p className="text-gray-700 mb-6" data-id="element-300">As part of the study:</p>
              <ul className="space-y-4 mb-6" data-id="element-301">
                <li className="flex items-start" data-id="element-302">
                  <div className="mt-1 mr-3 text-blue-500" data-id="element-303">
                    <CheckCircleIcon size={18} data-id="element-304" />
                  </div>
                  <div data-id="element-305">
                    <span className="font-medium text-gray-800" data-id="element-306">
                      Randomised year-group assignment
                    </span>
                    <p className="text-gray-600 text-sm" data-id="element-307">
                      Year groups will be randomly assigned to either use Eedi
                      or act as a comparison group
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-308">
                  <div className="mt-1 mr-3 text-blue-500" data-id="element-309">
                    <CheckCircleIcon size={18} data-id="element-310" />
                  </div>
                  <div data-id="element-311">
                    <span className="font-medium text-gray-800" data-id="element-312">
                      Progress tracking
                    </span>
                    <p className="text-gray-600 text-sm" data-id="element-313">
                      All students complete baseline, midline, and endline STAR
                      assessments
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-314">
                  <div className="mt-1 mr-3 text-blue-500" data-id="element-315">
                    <CheckCircleIcon size={18} data-id="element-316" />
                  </div>
                  <div data-id="element-317">
                    <span className="font-medium text-gray-800" data-id="element-318">
                      Post-study access
                    </span>
                    <p className="text-gray-600 text-sm" data-id="element-319">
                      After the study concludes, all classes gain full access to
                      Eedi
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}